import MessageBox from "sap/m/MessageBox";
import JSONModel from "sap/ui/model/json/JSONModel";

export default class ErrorService {

  private static _instance: ErrorService;

  private languageModel: JSONModel;

  public static getInstance() {
    if (!this._instance) {
      this._instance = new ErrorService();
    }
    return this._instance;
  }

  public init(languageModel: JSONModel) {
    this.languageModel = languageModel;
  }

  public showErrorMessageBox(sMessage: string, sTitle?: string) {
    sTitle = sTitle ? sTitle : this.languageModel.getProperty("ErrorTitle");
    MessageBox.error(sMessage, {
      id: "odataErrorMessageBox",
      title: sTitle,
      actions: [MessageBox.Action.CLOSE],
      onClose: () => {
      },
    });

  }

  public async showResponseErrors(content: any): Promise<void> {
    let message = content.message;
    if (content.additionalInfo) {
      message = content.additionalInfo.map((x: any) => x.Message).join("\n");
    }

    if(content.error?.ValidationErrors) {
        message = content.error?.ValidationErrors.map((x: any) => x.Message).join("\n");
    }

    this.showErrorMessageBox(message);
  }

  public showAPIServiceError(response: any) {
    const responseJson = Array.isArray(response.responseJSON) ? response.responseJSON[0] : response.responseJSON;
    const sMessage = `Status Code :${response.status}\n error: ${responseJson ? responseJson.message : response.responseText}`;
    this.showErrorMessageBox(sMessage);
  }

}
